<template>
  <div>
    <State :callbackSelect="selectGroup"></State>
    <div class="d-flex my-3">
      <v-spacer></v-spacer>
      <div class="pr-2">
        <v-text-field v-model="bSize" label="Batch Size" required></v-text-field>
      </div>
      <div class="pr-2">
        <v-text-field v-model="bNumber" label="Batch Number" required></v-text-field>
      </div>
      <JsonExcel ref="jsonExcel" :key="reportKey" :name="reportName" worksheet="Hamochi" :data="printData">
        <v-btn color="primary" :loading="apiDownload.isLoading" dark @click="downloadExcel">
          Download Excel
        </v-btn>
      </JsonExcel>
    </div>
    <div v-if="!api.isLoading && isPaginated" ref="printMe">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">#</th>
               <th class="text-left">Event Player ID</th>
              <th class="text-left">Event Finisher ID</th>
               <th class="text-left">Mochi ID</th>
              <th class="text-left">School Year</th>
              <!-- <th class="text-left">Ranking</th> -->
              <th class="text-left">School Name</th>
              <th class="text-left">Classroom Name</th>
              <th class="text-left">Student Name</th>
              <th class="text-left">State</th>
              <th class="text-left">Gender</th>
              <th class="text-left">Race</th>
              <th class="text-left">NRIC/Passport No</th>
              <th class="text-left">Email Address (MOE Email)</th>
               <th class="text-left">Total Attempts</th>
              <th class="text-left">Total Submissions</th>
              <th class="text-left">Total Score</th>
              <th class="text-left">Total Stars</th>
              <!-- <th class="text-left">Involvement</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, a) in data" :key="item.id">
              <td>{{ a + 1 }}</td>
               <td>{{ item.id }}</td>
               <td><span v-if="item.Finisher">{{ item.Finisher.id }}</span>
                <span v-else>-</span>
              </td>
                <td><span v-if="item.mochiId">{{ item.mochiId }}</span>
                <span v-else>-</span>
              </td>
              <td>{{ item.User.schoolYear }}</td>
              <!-- <td>{{ item.rank }}</td> -->
              <td>
                <span v-if="item.User.mainInstitution && item.User.mainInstitution != ''"> {{
                  item.User.mainInstitution.toUpperCase() }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="item.User.mainClassroom && item.User.mainClassroom != ''"> {{
                  item.User.mainClassroom.toUpperCase() }}</span>
                <span v-else>-</span>
              </td>
              <td>{{ item.User.name.toUpperCase() }}</td>
              <td><span v-if="item.User.state && item.User.state != ''">{{ item.User.state.toUpperCase() }}</span><span
                  v-else>-</span></td>
              <td>
                <span v-if="item.User.gender && item.User.gender == 'other'">{{
                  item.User.originalGender.toUpperCase()
                }}</span><span v-else-if="item.User.gender && item.User.gender != ''">{{ item.User.gender.toUpperCase()
                  }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="item.User.race && item.User.race == 'other'">{{
                  item.User.originalRace.toUpperCase()
                }}</span><span v-else-if="item.User.race && item.User.race != ''">{{ item.User.race.toUpperCase()
                  }}</span>
                <span v-else>-</span>
              </td>
              <td><span v-if="item.User.moeNumber && item.User.moeNumber != ''">{{ item.User.moeNumber.toUpperCase()
                  }}</span>
                <span v-else>-</span>
              </td>
              <td><span v-if="item.User.email && item.User.email != ''">{{ item.User.email }}</span>
                <span v-else>-</span>
              </td>
              <td>{{ item.totalAttempt }}</td>
              <td>{{ item.totalSubmission }}</td>
              <td>{{ item.totalScore }}</td>
              <td>{{ item.totalStar }}</td>
              <!-- <td>{{ item.involvement }}%</td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="text-center" v-if="!api.isLoading">
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination v-model="page" class="my-4" :length="totalPages"></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- BOC:[loader] -->
    <ALoader :isLoading="api.isLoading"></ALoader>
    <!-- EOC -->
  </div>
</template>

<script>
import { mapState } from "vuex";

import JsonExcel from "vue-json-excel";
//BOC: [print]
import VueHtml2Canvas from "vue-html2canvas";
import Vue from "vue";
import State from "./State.vue";
Vue.use(VueHtml2Canvas);
//EOC
export default {
  components: {
    State,
    JsonExcel,
  },
  computed: mapState({
    //
  }),
  props: ["eventCode"],
  data: () => ({
    reportKey: 0,
    data: [],
    printData: [],
    groupId: null,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    apiDownload: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    loading: false,
    //BOC:[pagination]
    page: 1,
    totalPages: 5,
    limit: 10,
    isLoading: false,
    isPaginated: true,
    state: null,
    bSize: 100,
    bNumber: 1,
    reportName: '',
    //EOC
  }),
  created() { },
  watch: {
    page: function () {
      this.fetch();
    },
  },
  mounted() { },
  methods: {
    selectGroup(val) {
      this.state = val;
      this.fetch();
    },
    fetch() {
      this.isLoading = true;
      //BOC:[api]
      this.api.method = "get";
      this.api.url = `${this.$api.servers.event}/api/v1/en/moderator/event/${this.$route.params.id}/user/report?limit=${this.limit}&page=${this.page}&isPaginated=${this.isPaginated}&state=${this.state}`;
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        this.data = []
      };
      this.api.callbackSuccess = (resp) => {
        this.data = resp.data;
        this.isLoading = false;
        this.api.isLoading = false;
        this.page = resp.page;
        this.totalPages = resp.totalPages;
      };
      //EOC
      this.$api.fetch(this.api);
    },
    async downloadExcel() {
      this.apiDownload.isLoading = true;
      this.reportKey++;

      // Fetch all data
      this.apiDownload.method = "get";
      this.apiDownload.url = `${this.$api.servers.event}/api/v1/en/moderator/event/${this.$route.params.id}/user/report?limit=${this.bSize}&page=${this.bNumber}&isPaginated=true&state=${this.state}`;

      this.apiDownload.callbackReset = () => {
        this.apiDownload.isLoading = true;
        this.apiDownload.isError = false;
      };

      this.apiDownload.callbackError = (e) => {
        this.apiDownload.isLoading = false;
        this.apiDownload.isError = true;
        this.apiDownload.error = e;
      };

      this.apiDownload.callbackSuccess = (resp) => {
        try {
          const allData = resp.data;
          this.printData = []
          this.reportName = `event_report_batch_${this.bNumber}.xls`
          this.printData = allData.map((obj, index) => ({
            'No': index + 1 + (this.bNumber - 1) * this.bSize,
            'Event Player ID': obj.id,
            'Event Finisher ID': obj.Finisher ? obj.Finisher.id:'N/A',
            'Mochi ID': obj.mochiId? obj.mochiId : "N/A",
            'School Year': obj.User ? obj.User.schoolYear : "N/A",
            'School Name': obj.User && obj.User.mainInstitution && obj.User.mainInstitution != '' ? obj.User.mainInstitution.toUpperCase() : "N/A",
            'Classroom Name': obj.User && obj.User.mainClassroom && obj.User.mainClassroom != '' ? obj.User.mainClassroom.toUpperCase() : "N/A",
            // 'Ranking': obj.rank,
            'Student Name': obj.User && obj.User.name ? obj.User.name.toUpperCase() : "N/A",
            'State': obj.User && obj.User.state && obj.User.state != '' ? obj.User.state.toUpperCase() : "N/A",
            'Gender': obj.User && obj.User.gender === 'other' ? obj.User.originalGender.toUpperCase() : obj.User && obj.User.gender && obj.User.gender != '' ? obj.User.gender.toUpperCase() : "N/A",
            'Race': obj.User && obj.User.race === 'other' ? obj.User.originalRace.toUpperCase() : obj.User && obj.User.race && obj.User.race != '' ? obj.User.race.toUpperCase() : "N/A",
            'NRIC/Passport No': obj.User && obj.User.moeNumber && obj.User.moeNumber != '' ? obj.User.moeNumber.toUpperCase() : "N/A",
            'Email Address (MOE Email)': obj.User && obj.User.email ? obj.User.email : "N/A",
            'Total Attempts': obj.totalAttempt,
            'Total Submissions': obj.totalSubmission,
            'Total Score': obj.totalScore,
            'Total Stars': obj.totalStar,
            // 'Involvement(%)': obj.involvement,
          }))

          this.$nextTick(() => {
            if (this.printData.length && this.$refs.jsonExcel) {
              setTimeout(() => {
                this.$refs.jsonExcel.generate();
              }, 200);
            }
          });
        }
        catch (e) {
          console.log(e);
        }
        finally {
          this.apiDownload.isLoading = false;
        }
      };

      this.$api.fetch(this.apiDownload);
    },
  },
};
</script>